import loadEmbedding from './loadEmbedding';
export {
// eslint-disable-next-line import/prefer-default-export
loadEmbedding };